// extracted by mini-css-extract-plugin
module.exports = {"section":"G_section__OHrGa","scrollLeft":"G_scrollLeft__ECio_"};